import { createContext, useContext, useEffect } from "react";
import type { ReactNode } from "react";

import type { PixatwinSdk } from "../types";

const PixatwinSdkContext = createContext<PixatwinSdk | null>(null);

export interface PixatwinSdkProviderProps {
  children: ReactNode;
  sdk: PixatwinSdk;
}

export const PixatwinSdkProvider = ({
  children,
  sdk,
}: PixatwinSdkProviderProps) => {
  useEffect(() => {
    sdk.start();

    return () => {
      sdk.stop();
    };
  }, [sdk]);

  return (
    <PixatwinSdkContext.Provider value={sdk}>
      {children}
    </PixatwinSdkContext.Provider>
  );
};

export const usePixatwinSdk = (): PixatwinSdk => {
  const sdk = useContext(PixatwinSdkContext);

  if (!sdk) {
    throw new Error(
      "usePixatwinSdk doit être utilisé à l'intérieur de PixatwinSdkProvider.",
    );
  }

  return sdk;
};
